import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solution',
  standalone: true,
  templateUrl: './solution.component.html',
  styleUrls: ['./solution.component.css']
})
export class SolutionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
